'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import initDataDog from '~/utilities/datadog';

type OwnProps = {
  correlationId: string;
  replaySampleRate?: number;
  sampleRate?: number;
};

/**
 * Client Component for DataDog RUM initialization
 * Used by DataDogInitializer server component
 *
 * Initializes DataDog RUM once with the initial server-generated correlationId.
 * Subsequent correlationId updates during SPA navigation are handled by the DataDogRumSync component
 */

export default function DataDogInitClient({
  correlationId,
  replaySampleRate,
  sampleRate
}: OwnProps) {
  useEffectOnce(() => {
    initDataDog(correlationId, sampleRate, replaySampleRate);
  }, [correlationId, replaySampleRate, sampleRate]);

  return null;
}
